// Central logging utility. All console output in the app should go through
// this module instead of calling `console.*` directly, so logs can be
// silenced in production builds from a single place.
const isProd = process.env.NODE_ENV === 'production';

const noop = () => {};

const logger = {
  log: isProd ? noop : console.log.bind(console),
  info: isProd ? noop : console.info.bind(console),
  warn: isProd ? noop : console.warn.bind(console),
  error: isProd ? noop : console.error.bind(console),
  debug: isProd ? noop : console.debug.bind(console),
};

export default logger;
